<template>
  <div id="app">
    <!-- 头部 -->
    <!-- <Head v-if="$route.meta.isShow" @login="onLogin" @register="onRegister" /> -->
    <!-- 导航 -->

    <el-container>
      <el-header style="padding: 0px;height: 80px;position: fixed;top: 0;left: 0;right: 0;z-index: 100">
        <Menu v-if="$route.meta.isShow" />
      </el-header>
      <el-main style="padding: 0px;position: relative">
		  <router-view :key="$route.fullPath"></router-view>
        <!-- <keep-alive>
          <router-view :key="$route.fullPath"></router-view>
        </keep-alive> -->
      </el-main>
      <el-footer style="padding: 0px;" v-if="$route.meta.isFooter">
        <Footer />
      </el-footer>
    </el-container>
    <!-- 登录弹框 -->
    <!-- <Login ref="login" @edit="onEdit" @register="onRegister" /> -->
    <!-- 忘记密码 -->
    <!-- <ForgetPassword ref="forgetPassword" @login="onLogin" /> -->
    <!-- 注册弹框 -->
    <!-- <Register ref="register" /> -->
  </div>
</template>

<script>
// import Head from '@/components/Head.vue'
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'
// import Login from '@/components/Login.vue'
// import ForgetPassword from '@/components/ForgetPassword.vue'
// import Register from '@/components/Register.vue'

export default {
  name: "Layout",
  components: {
    // Head,
    Menu,
    Footer,
    // Login,
    // ForgetPassword,
    // Register
  },
  data() {
    return {

      activeIndex: '1',
      company: {
        qrcode: require("../../static/other/公众号二维码.jpg"),
      },
      scroll: '',
      timer: '',
      seen: true,
      currentMenu: '首页'
    };
  },
  methods: {
    // 登录
    onLogin() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.login.open()
        }, 500)
      })
    },
    // 修改密码
    onEdit() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.forgetPassword.open()
        }, 500)
      })
    },
    // 注册
    onRegister() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.register.open()
        }, 500)
      })
    }
  },

  mounted() {

  }

}
</script>

<style>
html {
  background-color: #dfe2e9;
}

#menu_index {
  float: left;
  width: 50%;
  height: 100%
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
</style>
